import { Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import itemBreadcrumb from './itemBreadcrumb';
import { Breadcrumb, Card, Title } from './styles';

export default function SubHeader({ title, breadcrumbs, bordered }) {
  return (
    <Card bordered={bordered}>
      <Row gutter={12} type="flex" justify="space-between" align="middle">
        {title && <Title strong>{title}</Title>}
        {breadcrumbs && (
          <Breadcrumb
            itemRender={title ? undefined : itemBreadcrumb}
            routes={breadcrumbs}
          />
        )}
      </Row>
    </Card>
  );
}

SubHeader.propTypes = {
  title: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      breadcrumbName: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          path: PropTypes.string,
          breadcrumbName: PropTypes.string,
        })
      ),
    })
  ),
  bordered: PropTypes.bool,
};

SubHeader.defaultProps = {
  title: undefined,
  breadcrumbs: [],
  bordered: false,
};
